module.exports = __webpack_public_path__ + "img/connect_wires_w_wedge.823f94ce.png";